import { useEffect, useState } from 'react';
import { isWindowExists } from '../utils';

export function useWindowDimensions() {
  const hasWindow = isWindowExists();
  const [dimensions, setDimensions] = useState({
    height: hasWindow ? window.innerHeight : 0,
    width: hasWindow ? window.innerWidth : 0,
  });

  useEffect(() => {
    if (isWindowExists()) {
      const handleResize = () => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth,
        });
      };

      window.addEventListener('resize', handleResize);
      handleResize();

      return () => window.removeEventListener('resize', handleResize);
    }
    return undefined;
  }, []);

  return dimensions;
}
